module.exports = __webpack_public_path__ + "static/img/lbbg4.1486424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbbg4.png
// module id = AmIo
// module chunks = 0